module.exports = __webpack_public_path__ + "static/media/evasivestrike.844305d0.jpeg";